import PictureColor from './PictureColour.svg';
import PictureDark from './PictureDark.svg';
import PictureLight from './PictureLight.svg';
export const picture = { color: PictureColor, dark: PictureDark, light: PictureLight };
//# sourceMappingURL=index.js.map